(function () {
var $776121dd101ef8fe$exports = {};
var $776121dd101ef8fe$var$sourceMap = {
    tpi: "https://player.vimeo.com/video/831298106?h=71c4c68c58&autoplay=1",
    mmb: "https://player.vimeo.com/video/964752254?h=3d06214e4e&autoplay=1",
    calibr: "https://player.vimeo.com/video/841462245?h=a2d720636d&autoplay=1",
    lvf: "https://player.vimeo.com/video/841463139?h=5deb0572e0&autoplay=1",
    uncf: "https://player.vimeo.com/video/841463944?h=5692ed7e94&autoplay=1",
    wgu: "https://player.vimeo.com/video/1046542744?h=f64bf15feb&autoplay=1"
};
function $776121dd101ef8fe$var$isKeyofSourceMap(key) {
    return !!key && key in $776121dd101ef8fe$var$sourceMap;
}
var $776121dd101ef8fe$var$buttons = document.querySelectorAll("button");
$776121dd101ef8fe$var$buttons.forEach(function(button) {
    button.addEventListener("click", function(event) {
        var key = event.currentTarget.dataset.videoKey;
        if ($776121dd101ef8fe$var$isKeyofSourceMap(key)) $776121dd101ef8fe$var$replaceVideo($776121dd101ef8fe$var$sourceMap[key]);
    });
});
function $776121dd101ef8fe$var$replaceVideo(nextSource) {
    var iframe = document.querySelector("iframe");
    iframe.src = nextSource;
}

})();
//# sourceMappingURL=video.b11b38ec.js.map
